import { PropsHtag } from './PropsTag';
import classNames from 'classnames';

import styles from './Tag.module.scss';

export const Tag = ({ tag, children, color, weight, size, className, id }: PropsHtag): JSX.Element => {
  switch (tag) {
    case 'h1':
      return (
        <h1 style={{ color, fontWeight: weight, fontSize: size }} id={id} className={classNames(styles.h1, className)}>
          {children}
        </h1>
      );
    case 'h2':
      return (
        <h2 style={{ color, fontWeight: weight, fontSize: size }} id={id} className={classNames(styles.h2, className)}>
          {children}
        </h2>
      );
    case 'h3':
      return (
        <h3 style={{ color, fontWeight: weight, fontSize: size }} id={id} className={classNames(styles.h3, className)}>
          {children}
        </h3>
      );
    default:
      return <></>;
  }
};
